import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '../../common/enums/api-status';
import { createKnowledgeBaseAsync, deleteKnowledgeBaseAsync, getKnowledgeBasesAsync, getKnowledgeBaseByIdAsync, updateKnowledgeBaseAsync } from './knowledgeBaseThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const knowledgeBaseSlice = createSlice({
    name: 'knowledgeBase',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getKnowledgeBasesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getKnowledgeBasesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.allKnowledgeBases = action.payload;
        })
            .addCase(getKnowledgeBasesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createKnowledgeBaseAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createKnowledgeBaseAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.knowledgeBase = action.payload;
        })
            .addCase(createKnowledgeBaseAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getKnowledgeBaseByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getKnowledgeBaseByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.knowledgeBase = action.payload;
        })
            .addCase(getKnowledgeBaseByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateKnowledgeBaseAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateKnowledgeBaseAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.knowledgeBase = action.payload;
        })
            .addCase(updateKnowledgeBaseAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteKnowledgeBaseAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteKnowledgeBaseAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            // action.payload is boolean indicating success
            // Remove the deleted item from allKnowledgeBases if needed
        })
            .addCase(deleteKnowledgeBaseAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default knowledgeBaseSlice.reducer;
